/* @flow */
import * as React from "react";
import styled from "styled-components";
// import screenfull from "screenfull";

import Gettext from "../../common/Gettext";
import ToolWrapper from "../../Toolbar/ToolWrapper";
import ToolsContent from "../../Toolbar/ToolsContent";
import ToolsMenu from "../../Toolbar/ToolsMenu";
import ToolsActive from "../../Toolbar/ToolsActive";
import Popup from "../Popup";

const Inner = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: flex-start;
  align-content: flex-start;
  height: 100%;
  width: 100%;
  flex: 1;
`;

type Props = {
  onClick?: () => void
};

export default function ToolsPopup(props: Props) {
  return (
    <Popup title={<Gettext>Settings</Gettext>} onClick={props.onClick}>
      <Inner>
        <ToolWrapper isMobile>
          {tools =>
            tools.instruments === "settings" ? (
              <React.Fragment>
                <ToolsMenu
                  tools={tools.TOOLS}
                  activeTool={tools.activeTool}
                  changeActiveTool={tools.changeActiveTool}
                  isMobile
                />
                <ToolsContent
                  activeTool={tools.activeToolObj}
                  isMobile
                  dispatch={tools.dispatch}
                  settings={tools.settings}
                >
                  <ToolsActive
                    tools={tools.TOOLS}
                    handlePopupOpen={tools.handlePopupOpen}
                    activeTool={tools.activeTool}
                    dispatch={tools.dispatch}
                    settings={tools.settings}
                    isMobile
                  />
                </ToolsContent>
              </React.Fragment>
            ) : (
              tools.popup
            )
          }
        </ToolWrapper>
      </Inner>
    </Popup>
  );
}



// WEBPACK FOOTER //
// ./src/components/TradeMobile/Toolbar/ToolsPopup.js